import { CaretDownOutlined, CaretRightOutlined } from "@ant-design/icons";
import { Checkbox, Table, TableColumnsType } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useToast from "../../../../../hook/useToast";
import * as fomartUnit from "../../../../../services/fomartUnit"
import * as decentralizationApi from '../../../../../api/configuration/decentralizationApi';

interface Prop {
  listMenu: decentralizationApi.IDecentralization[]

  setListMenu: React.Dispatch<React.SetStateAction<decentralizationApi.IDecentralization[]>>
}

const FeatureAuthorization: React.FC<Prop> = ({
  listMenu,
  setListMenu
}) => {

  const [checkAll, setCheckAll] = useState(false);

  const columns: TableColumnsType<decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization> = [
    {
      title: <div className="d-flex justify-center"><Checkbox
        checked={checkAll}
        onChange={(e) => handleCheckAllMenu(e.target.checked)}
      />
      </div>,
      key: 'key',
      render: (_, value: decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization) =>
        <Checkbox
          checked={value.add && value.edit && value.delete && value.access && value.upload && value.download ? true : false}
          onChange={(e) => handleCheckAllParent(e.target.checked, value.id, value.parentId)}
        />,
      width: '5%'
    },
    {
      title: 'STT',
      key: 'id',
      dataIndex: 'stt',
      className: "w-71-px",
      align: 'center'
    },
    {
      title: 'Quyền',
      key: 'name',
      dataIndex: 'name',
      className: 'w-386-px ',
    },
    {
      title: 'Truy cập',
      dataIndex: 'access',
      render: (_, value: decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization) =>
        <Checkbox
          className="size-check-box size-check-box-inner p-checkbox icon-check-box"
          checked={value.access}
          onChange={(e) => handleChangeType(e.target.checked, value.id, "access", value.parentId)}
        />,

      className: 'w-100-px',
      align: 'center',
    },
    {
      title: 'Thêm mới',
      dataIndex: 'add',
      render: (_, value: decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization) =>
        <Checkbox
          className="size-check-box size-check-box-inner p-checkbox icon-check-box"
          checked={value.add}
          onChange={(e) => handleChangeType(e.target.checked, value.id, "add", value.parentId)}
        />,
      className: 'w-100-px',
      align: 'center',
    },
    {
      title: 'Sửa',
      dataIndex: 'edit',
      render: (_, value: decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization) =>
        <Checkbox
          className="size-check-box size-check-box-inner p-checkbox icon-check-box"
          checked={value.edit}
          onChange={(e) => handleChangeType(e.target.checked, value.id, "edit", value.parentId)}
        />,

      className: 'w-100-px',
      align: 'center',
    },
    {
      title: 'Xoá',
      dataIndex: 'delete',
      render: (_, value: decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization) =>
        <Checkbox
          className="size-check-box size-check-box-inner p-checkbox icon-check-box"
          checked={value.delete}
          onChange={(e) => handleChangeType(e.target.checked, value.id, "delete", value.parentId)}
        />,

      className: 'w-100-px',
      align: 'center',
    },
    {
      title: 'Tải lên',
      dataIndex: 'upload',
      render: (_, value: decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization) =>
        <Checkbox
          className="size-check-box size-check-box-inner p-checkbox icon-check-box"
          checked={value.upload}
          onChange={(e) => handleChangeType(e.target.checked, value.id, "upload", value.parentId)}
        />,

      className: 'w-100-px',
      align: 'center',
    },
    {
      title: 'Tải về',
      dataIndex: 'download',
      render: (_, value: decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization) =>
        <Checkbox
          className="size-check-box size-check-box-inner p-checkbox icon-check-box"
          checked={value.download}
          onChange={(e) => handleChangeType(e.target.checked, value.id, "download", value.parentId)}
        />,

      className: 'w-100-px',
      align: 'center',
    },
    {
      title: 'Phê duyệt',
      dataIndex: 'approve',
      render: (_, value: decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization) =>
        <Checkbox
          className="size-check-box size-check-box-inner p-checkbox icon-check-box"
          checked={value.approve}
          onChange={(e) => handleChangeType(e.target.checked, value.id, "approve", value.parentId)}
        />,

      className: 'w-100-px',
      align: 'center',
    },

  ];


  const handleCheckAllMenu = (checked: boolean) => {
    setCheckAll(checked);

    // gán toàn bộ quyền của 1 node
    const updateAllFields = (
      node: decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization
    ) => {
      node.access = checked;
      node.add = checked;
      node.edit = checked;
      node.delete = checked;
      node.upload = checked;
      node.download = checked;
      node.approve = checked;
    };

    // áp dụng cho toàn bộ cây (đa cấp)
    const updateTree = (
      tree: decentralizationApi.IDecentralization[]
    ): decentralizationApi.IDecentralization[] => {
      return tree.map(root => {
        const updateNode = (node: any): any => {
          const cloned = { ...node };

          updateAllFields(cloned);

          if (cloned.children && cloned.children.length > 0) {
            cloned.children = cloned.children.map((child: any) =>
              updateNode(child)
            );
          }

          return cloned;
        };

        return updateNode(root);
      });
    };

    const newTree = updateTree(listMenu);
    setListMenu(newTree);
  };

  const autoCheckAllMenu = (
    updatedData: decentralizationApi.IDecentralization[]
  ) => {
    const checkNode = (
      node: decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization
    ): boolean => {

      const selfChecked =
        node.access &&
        node.add &&
        node.edit &&
        node.delete &&
        node.upload &&
        node.download &&
        node.approve;

      if (!selfChecked) return false;

      if (!node.children || node.children.length === 0) {
        return true;
      }

      return node.children.every(child => checkNode(child));
    };

    const allChecked = updatedData.every(node => checkNode(node));

    setCheckAll(allChecked);
    return allChecked;
  };


  const handleCheckAllParent = (
    checked: boolean, id: number, parentId?: number
  ) => {
    const PERMS = ["access", "add", "edit", "delete", "upload", "approve", "download"];

    const dfs = (node: any): any => {
      let clone = { ...node };

      // 1. Duyệt con trước
      if (clone.children?.length) {
        clone.children = clone.children.map(dfs);
      }

      // 2. Nếu là node cần update → tick toàn subtree
      if (clone.id === id) {
        const updateBranch = (n: any): any => {
          const c = { ...n };
          PERMS.forEach(p => (c[p] = checked));

          if (c.children?.length) {
            c.children = c.children.map(updateBranch);
          }
          return c;
        };
        clone = updateBranch(clone);
        return clone; // xong node này → return luôn
      }

      // 3. Không phải node target → cascade lên tự nhiên
      if (clone.children?.length) {
        PERMS.forEach(p => {
          clone[p] = clone.children.some((c: any) => c[p]);
        });
      }

      return clone;
    };

    const updated = listMenu.map(dfs);
    setListMenu(updated);
  };

  const handleChangeType = (
    value: boolean, id: number, type: "access" | "add" | "edit" | "delete" | "upload" | "approve" | "download", parentId?: number
  ) => {
    type Node = decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization;
    type PermissionKey = "access" | "add" | "edit" | "delete" | "upload" | "approve" | "download";

    const PERMS: PermissionKey[] = [
      "access", "add", "edit", "delete",
      "upload", "approve", "download"
    ];

    const CHILD_PERMS: PermissionKey[] = [
      "add", "edit", "delete", "upload",
      "approve", "download"
    ];

    const dfs = (node: Node, isTargetAncestor = false): Node => {
      const clone: Node = { ...node };

      const isTarget = clone.id === id;
      const cascadeDown = isTargetAncestor || isTarget;

      // -------------------------
      // 1) Node được click
      // -------------------------
      if (isTarget) {
        clone[type] = value;

        // Nếu bật quyền khác access → bật access
        if (value && type !== "access") {
          clone.access = true;
        }

        // Nếu uncheck access → uncheck tất cả quyền khác
        if (!value && type === "access") {
          CHILD_PERMS.forEach(p => (clone[p] = false));
        }
      }

      // -------------------------
      // 2) Duyệt children trước
      // -------------------------
      if (clone.children && clone.children.length > 0) {
        clone.children = clone.children.map(child =>
          dfs(child, cascadeDown)
        );
      }

      // -------------------------
      // 3) Cascade xuống
      // -------------------------
      if (cascadeDown) {
        clone[type] = value;

        // Bật quyền khác access → auto bật access
        if (value && type !== "access") {
          clone.access = true;
        }

        // Uncheck access → uncheck toàn bộ quyền khác
        if (!value && type === "access") {
          CHILD_PERMS.forEach(p => (clone[p] = false));
        }
      }

      // -------------------------
      // 4) Cascade lên (tổng hợp từ children)
      // -------------------------
      if (clone.children && clone.children.length > 0) {
        PERMS.forEach(p => {
          clone[p] = clone.children!.some(child => child[p]);
        });
      }

      // -------------------------
      // 5) Nếu có quyền nào bật → access phải bật
      // -------------------------
      if (CHILD_PERMS.some(p => clone[p])) {
        clone.access = true;
      }

      return clone;
    };

    const updated = listMenu.map(root => dfs(root)) as decentralizationApi.IDecentralization[];
    setListMenu(updated);

    if (value)
      autoCheckAllMenu(updated);
    else
      setCheckAll(false);
  };


  return (
    <div>
      <div className="custom-page-css font-medium text-base pb-2">Thiết lập quyền theo tính năng</div>
      {/* <DrawerDataField
                show={showDataFieldDrawer}

                onFinishDrawerDataField={onFinishDrawerDataField}
                onClose={() => setShowDataFieldDrawer(false)}
            /> */}
      <div className="pb-18-px">
        <div className="t-table-block ">
          <Table
            rowClassName={(record, index) => index % 2 === 0 ? 'table-row-dark' : 'table-row-light'}
            columns={columns}
            dataSource={listMenu}
            pagination={false}
            showSorterTooltip={false}
            // rowSelection={{
            //   type: 'checkbox',
            //   ...handleRowSelection, checkStrictly
            // }}
            style={{
              maxHeight: '520px',
              overflowY: 'scroll'
            }}
            className=" border-end-table  "
            expandable={{
              expandIcon: ({ expanded, onExpand, record }) =>
                record.children?.length ? (
                  expanded ? (
                    <CaretDownOutlined className={` pr-1 text-8E8E8E`} onClick={e => onExpand(record, e)} />
                  ) : (
                    <CaretRightOutlined className={` pr-1 text-8E8E8E`} onClick={e => onExpand(record, e)} />
                  )
                ) : (
                  <CaretDownOutlined className={` `} style={{ opacity: 0 }} />
                ),
              // defaultExpandAllRows: true
            }}
          />
        </div>
      </div>

    </div>
  )
}

export default FeatureAuthorization
